import { useQuery } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";
import { opcoesConsultaResiliente } from "shared/util/consultaResiliente";

export const useGetEmailRedirecionamento = () => {
  return useQuery<Cond21CloudResponse<string>>({
    queryKey: ["email-redirecionamento-group-pay"],
    queryFn: async () => {
      const response = await http.get<Cond21CloudResponse<string>>(
        api.groupPay.getConfiguracaoEmailRedirecionamento
      );
      return response.data;
    },
    staleTime: Infinity,
    ...opcoesConsultaResiliente(
      "email-redirecionamento-group-pay",
      "Erro ao buscar o e-mail de redirecionamento do Group Pay"
    ),
  });
};